import { useCurrentUser } from '@euler/app/flows/auth/context';
import { config } from '@euler/config';
import { isDebugEnabled } from '@euler/functions/debug';
import * as WeWork from '@euler/lib/integration/wework/WeWork';
import { makeDebug } from '@euler/utils';
import { memo, useEffect } from 'react';
import { Platform } from 'react-native';

const debug = makeDebug('wework', isDebugEnabled('wework'));

export const WeWorkRegistration = memo(() => {
  const authenticatedUser = useCurrentUser();

  const corpId =
    authenticatedUser?.store?.weworkApiCorpId?.trim() &&
    authenticatedUser.store.weworkApiAgentId?.trim()
      ? authenticatedUser.store.weworkApiCorpId.trim()
      : authenticatedUser?.org.weworkApiCorpId?.trim() ?? undefined;

  const agentId =
    authenticatedUser?.store?.weworkApiAgentId?.trim() &&
    authenticatedUser.store.weworkApiAgentId?.trim()
      ? authenticatedUser.store.weworkApiAgentId.trim()
      : authenticatedUser?.org.weworkApiAgentId?.trim() ?? undefined;

  useEffect(() => {
    debug(
      'try register wework:',
      JSON.stringify({ corpId, agentId, scheme: config.wework.urlScheme }),
    );
    // only works for iOS and organization with wework configured.
    if (!corpId || !agentId || Platform.OS !== 'ios') {
      void WeWork.unregisterApp().then(() => {
        debug('unregistered wework app');
      });
      return;
    }

    WeWork.registerApp(config.wework.urlScheme, corpId, agentId)
      .then(() => {
        debug('successfully registered wework app: %O', {
          scheme: config.wework.urlScheme,
          corpId,
          agentId,
        });
      })
      .catch(err => {
        console.error('failed to register wework app: ', err);
      });
  }, [agentId, corpId]);

  return null;
});
